import {charcoal} from '../sass/base/_exports.sass';

export const TriangleIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 12;
  const height = 14;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00001 3.482V10.518L8.03001 7L2.00001 3.482ZM0.75201 0.439998L11.26 6.57C11.3353 6.61408 11.3978 6.6771 11.4412 6.7528C11.4846 6.8285 11.5074 6.91424 11.5074 7.0015C11.5074 7.08876 11.4846 7.17449 11.4412 7.25019C11.3978 7.32589 11.3353 7.38891 11.26 7.433L0.75201 13.563C0.675804 13.6075 0.589187 13.631 0.500955 13.6312C0.412722 13.6313 0.326016 13.6081 0.249641 13.564C0.173266 13.5198 0.109941 13.4562 0.0660977 13.3796C0.0222543 13.303 -0.000546618 13.2162 9.95048e-06 13.128V0.870997C-1.61235e-05 0.78302 0.0231715 0.696594 0.0672311 0.620445C0.111291 0.544296 0.174663 0.48112 0.250948 0.437297C0.327233 0.393473 0.413731 0.370554 0.501707 0.370852C0.589684 0.371151 0.676024 0.394657 0.75201 0.438998V0.439998Z"
        fill={color}
      />
    </svg>
  );
};
